import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import DashCards from '../Common/DashCards';
import { fetchApi } from '../utils/fetchApi';
import { axiosApi } from '../utils/axiosApi';
import ScatterChart from '../Charts/NewCharts/ScatterChart';
import ComboChart from '../Charts/NewCharts/ComboChart';
import HorizontalBarChart from '../Charts/NewCharts/HorizontalBarChart';
import GaugeChart from '../Charts/NewCharts/GaugeChart';
import DailyBurnGoalChart from '../Charts/NewCharts/DailyBurnGoalChart';

const EmpDash = () => {

  const userState = useSelector(state => state.loginData.userData);
  const roleOfUser = ["employee", "intern", "contractual"]
  // ---------------------- STATES & API TOGETHER --------------------------------
  const [empLeads, setEmpLeads] = useState([]);
  const [empValue, setEmpValue] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // for new graphs states
  const [eatTheFrogMatrix, setEatTheFrogMatrix] = useState([]);
  const [personalVelocityCorrelation, setPersonalVelocityCorrelation] = useState([]);
  const [slippageWarningZone, setSlippageWarningZone] = useState([]);
  const [personalQualityLoop, setPersonalQualityLoop] = useState(null);
  const [dailyBurnGoal, setDailyBurnGoal] = useState([]);

  useEffect(() => {
    totalCardsApis();
    getEatTheFrogMatrix();
    getPersonalVelocityCorrelation();
    getSlippageWarningZone();
    getPersonalQualityLoop();
    getDailyBurnGoal();
  }, [empValue, startDate, endDate])

  // ----- Lead/Manager List Fetching ----------
  useEffect(() => {
    getResoucewiseTL();
  }, [])

  const getResoucewiseTL = async () => {
    await fetchApi(process.env.REACT_APP_BASE_URL + "/emp/getEmployeeLeadOrManager", {
      body: { empId: userState?.empId }
    })
      .then((res) => res.json()).then((response) => {
        setEmpLeads(response?.data.lead_name);
      })
      .catch((err) => {
        console.log("Error while getting leads =>", err);
      });
  };

  // for new graphs implementation
  const getCommonPayload = () => ({
    fromDate: startDate || "",
    toDate: endDate || "",
    department_id: "",
    subDepartmentId: "",
    resource_id: "",
    projectId: "",
    status: "",
    empId: userState?.empId,
    lead: empValue ? empValue : ""
  });


  const fetchGraphData = async ({ endpoint, setState, defaultValue = [], isRiskMatrix = false, }) => {
    try {
      const payload = getCommonPayload();
      const res = await axiosApi(`${process.env.REACT_APP_BASE_URL}${endpoint}`, payload);
      setState(res?.data?.data || defaultValue);
    } catch (err) {
      console.log(err);
    }
  };

  const getEatTheFrogMatrix = () =>
    fetchGraphData({
      endpoint: "/graph/eatTheFrogMatrix",
      setState: setEatTheFrogMatrix,
      defaultValue: [],
    });

  const getPersonalVelocityCorrelation = () =>
    fetchGraphData({
      endpoint: "/graph/personalVelocityCorrelation",
      setState: setPersonalVelocityCorrelation,
      defaultValue: [],
    });

  const getSlippageWarningZone = () =>
    fetchGraphData({
      endpoint: "/graph/slippageWarningZone",
      setState: setSlippageWarningZone,
      defaultValue: [],
    });

  const getPersonalQualityLoop = () =>
    fetchGraphData({
      endpoint: "/graph/personalQualityLoop",
      setState: setPersonalQualityLoop,
      defaultValue: null,
    });

  const getDailyBurnGoal = () =>
    fetchGraphData({
      endpoint: "/graph/dailyBurnGoal",
      setState: setDailyBurnGoal,
      defaultValue: [],
    });

  // ----- Card State & API-------
  const [cardApiRes, setCardApiRes] = useState({});
  const totalCardsApis = async () => {
    const payload = {
      empId: userState?.empId,
      fromDate: startDate ? startDate : "",
      toDate: endDate ? endDate : "",
      lead: empValue ? empValue : ""
    };

    await axiosApi(process.env.REACT_APP_BASE_URL + "/empDashboard/empDashboardApi", payload)
      .then((res) => {
        setCardApiRes(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // for reset all data in dropdown
  const handleronChange = (selectedValue) => {
    if (selectedValue === "All") {
      setEmpValue("");
    } else {
      setEmpValue(selectedValue);
    }
  };

  const handleClear = () => {
    setStartDate("");
    setEndDate("");
    setEmpValue("");
  };

  return (
    <div className='EmpDash' data-aos='fade-up'>
      <Container>
        {roleOfUser.includes(userState.resourceType) ?
          <Row className='d-flex align-items-center justify-content-between w-100 mt-5'>

            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  {userState?.resourceType === "teamlead"
                    ? "Manager"
                    : userState?.resourceType === "employee"
                      ? "Lead"
                      : "Lead/manager"}
                </Form.Label>

                <Form.Select
                  style={{ width: '100%' }}
                  onChange={(e) => handleronChange(e.target.value)}
                >
                  <option value="All">All</option>

                  {empLeads?.map((row, index) => (
                    <option key={index} value={row}>
                      {row}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={6} className='d-flex justify-content-end mt-3 mt-md-0'>
              <Row className='w-100 align-items-end'>

                {/* From */}
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>From</Form.Label>
                    <Form.Control
                      type="date"
                      value={startDate}
                      onChange={(e) => {
                        setStartDate(e.target.value)
                        setEndDate("")
                      }}
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>To</Form.Label>
                    <Form.Control
                      type="date"
                      value={endDate}
                      min={startDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Button
                    className='clearBtn w-100'
                    onClick={handleClear}
                  >
                    Clear
                  </Button>
                </Col>
              </Row>
            </Col>

          </Row> :
          <Row className='d-flex align-items-center justify-content-between w-100 mt-0'>

            <Col md={3} className='mb-md-0'>
              <Form.Group>
                <Form.Label>
                  {userState?.resourceType === "teamlead"
                    ? "Manager"
                    : userState?.resourceType === "employee"
                      ? "Lead"
                      : "Lead/manager"}
                </Form.Label>

                <Form.Select
                  value={empValue}
                  onChange={(e) => handleronChange(e.target.value)}
                >
                  <option value="All">All</option>

                  {empLeads?.length > 0 &&
                    empLeads.map((row, index) => (
                      <option key={index} value={row}>
                        {row}
                      </option>
                    ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={6} className='d-flex justify-content-end mt-3 mt-md-0'>
              <Row className='w-100 align-items-end'>

                <Col md={5}>
                  <Form.Group>
                    <Form.Label>From</Form.Label>

                    <Form.Control
                      type="date"
                      value={startDate}
                      onChange={(e) => {
                        setStartDate(e.target.value)
                        setEndDate("")
                      }}
                    />
                  </Form.Group>
                </Col>

                <Col md={5}>
                  <Form.Group>
                    <Form.Label>To</Form.Label>
                    <Form.Control
                      type="date"
                      value={endDate}
                      min={startDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </Form.Group>
                </Col>

                <Col md={2}>
                  <Button
                    className='clearBtn w-100'
                    onClick={handleClear}
                  >
                    Clear
                  </Button>
                </Col>

              </Row>
            </Col>
          </Row>}

        <DashCards
          totalPro={cardApiRes?.totalProjects || 0}
          totalEst={cardApiRes?.totalEstimatedHrs?.toFixed(2) || 0}
          totalActTime={cardApiRes?.totalActualHrs?.toFixed(2) || 0}
          slippage={cardApiRes?.slippage?.toFixed(2) || 0}
          totalTask={cardApiRes?.totalTasks || 0}
          efficiency={cardApiRes?.efficiency?.toFixed(2) || 0}
          totalPendingTask={cardApiRes?.totalPending || 0}
          totalCompTask={cardApiRes?.totalCompleted || 0}
          avgQWD={isNaN(Number(cardApiRes?.avgQWD)) ? 0 : Number(cardApiRes?.avgQWD)?.toFixed(2) || 0}
          avgIDC={isNaN(Number(cardApiRes?.avgIDC)) ? 0 : Number(cardApiRes?.avgIDC)?.toFixed(2) || 0}
        />

        <div className="analyticsWrapper">
          <div className="analyticsHeader">
            <h3>Analytics</h3>
            <p>Charts & Visualizations</p>
          </div>
          <div className="dashboardGraphs">
            <Row className="g-4">
              {/* {eatTheFrogMatrix?.length > 0 && ( */}
                <Col lg={12} md={12} sm={12}>
                  <div className="graphCard">
                    <ScatterChart
                      chartLabel="Quick Win Tasks"
                      chartData={eatTheFrogMatrix}
                      purpose="Highlights High Priority / Low Estimate tasks (Quick Wins)."
                      fieldsLabel="initialEstimateHr vs taskPriority"
                      xField="initialEstimateHr"
                      yField="priorityScore"
                      colorField="taskPriority"
                      xAxisTitle="Initial Estimate (Hr)"
                      yAxisTitle="Priority"
                      yAxisMin={0}
                      yAxisMax={4}
                      yAxisInterval={1}
                      yAxisFormatter={(value) => {
                        switch (value) {
                          case 1:
                            return "Low";
                          case 2:
                            return "Medium";
                          case 3:
                            return "High";
                          case 4:
                            return "Urgent";
                          default:
                            return "";
                        }

                      }}

                      tooltipFields={[
                        {
                          key: "taskName",
                          label: "Task",
                        },
                        {
                          key: "resourceName",
                          label: "Resource",
                        },
                        {
                          key: "projectName",
                          label: "Project",
                        },
                        {
                          key: "taskPriority",
                          label: "Priority",
                        },
                        {
                          key: "proposedStartDate",
                          label: "Start Date",
                        },
                      ]}
                    />

                  </div>
                </Col>
              {/* )} */}

              {/* {personalVelocityCorrelation?.length > 0 && ( */}
                <Col lg={12} md={12} sm={12}>
                  <div className="graphCard">
                    <ComboChart
                      chartLabel="Estimated vs Actual Time"
                      chartData={personalVelocityCorrelation}
                      xField="date"
                      barField="totalActualHours"
                      lineField="totalEstimateHours"
                      xAxisTitle="Date"
                      leftAxisTitle="Actual Hours"
                      rightAxisTitle="Estimate Hours"
                      barLabel="Actual Hours"
                      lineLabel="Estimate Hours"
                      fieldsLabel="totalActualHours (Bar) vs totalEstimateHours (Line) "
                      purpose="Shows if the developer consistently underestimates their own work."
                      tooltipFields={[
                        {
                          key: "date",
                          label: "Date",
                        },
                        {
                          key: "totalTasks",
                          label: "Total Tasks",
                        },
                        {
                          key: "avgEfficiency",
                          label: "Avg Efficiency (%)",
                        },
                        {
                          key: "avgSlippage",
                          label: "Avg Slippage (%)",
                        },
                        // {
                        //   key: "efficiency",
                        //   label: "Efficiency (%)",
                        // },
                        // {
                        //   key: "proposedStartDate",
                        //   label: "Start Date",
                        // },
                      ]}
                    />

                  </div>
                </Col>
              {/* )} */}

              {/* {slippageWarningZone?.length > 0 && ( */}
                <Col lg={12} md={12} sm={12}>
                  <div className="graphCard">
                    <HorizontalBarChart
                      chartLabel="Top 10 Overdue Tasks"
                      chartData={slippageWarningZone}
                      fieldsLabel="Tasks sorted by proposedEndDate vs current time"
                      xField="overdueDays"
                      yField="taskName"
                      barColor="#ff7f4d"
                      purpose="Highlights tasks that are overdue."
                      legendLabel="Task Name"
                      xAxisTitle='Overdue Days'
                      yAxisTitle='Tasks'
                      tooltipFields={[
                        // { key: "resourceName", label: "Resource" },
                        { key: "taskPriority", label: "Priority" },
                        // { key: "estimateHours", label: "Estimate Hours" },
                        { key: "proposedEndDate", label: "Proposed End Date" },
                        // { key: "actualEndtDate", label: "Actual End Date" },
                      ]}
                    />
                  </div>
                </Col>
              {/* )} */}

              <Col lg={6} md={6} sm={12}>
                <div className="graphCard">
                  <GaugeChart
                    chartLabel="Personal Quality Loop"
                    chartData={personalQualityLoop}
                    fieldsLabel="Ratio of isRejected or reopenCount vs completed"
                    valueField="qualityScore"
                    statusField="gaugeStatus"
                    purpose="A self-check on code and requirement quality."
                    gaugeLabel="Quality Score"
                    tooltipFields={[
                      {
                        key: "completed",
                        label: "Completed",
                      },
                      {
                        key: "rejected",
                        label: "Rejected",
                      },
                      {
                        key: "reopened",
                        label: "Re-opened",
                      },
                      {
                        key: "qualityScore",
                        label: "Quality Score (%)",
                      },
                    ]}
                    showStatus={true}
                    showValue={false}
                    progressColor="#19B885"
                    backgroundColor="#E8EDF5"
                    pointerColor="#1E293B"
                    gaugeWidth={20}
                    pointerWidth={5}
                    pointerLength="62%"
                    radius="72%"
                    center={["50%", "72%"]}
                    min={0}
                    max={100}
                    startAngle={200}
                    endAngle={-20}
                    height={260}
                  />

                </div>
              </Col>

              <Col lg={6} md={6} sm={12}>
                <div className="graphCard">
                  <DailyBurnGoalChart
                    xAxisTitle='Employees'
                    yAxisTitle='Hours'
                    chartLabel="Personal Burn Goal"
                    chartData={dailyBurnGoal}
                    fieldsLabel="actualHours logged today against an 8-hour target"
                    purpose="Visual cue of daily productivity."
                    actualLabel="Actual Hours"
                    remainingLabel="Remaining Hours"
                  />
                </div>
              </Col>
            </Row>
          </div>
        </div>



      </Container>
    </div >
  )
}

export default EmpDash;